export default [
  {
    value: 'ara',
    label: 'Auvergne-Rhône-Alpes',
    states: ['01', '03', '07', '15', '26', '38', '42', '43', '63', '69', '73', '74'],
    coordinates: [
      [
        [4.6495238, 44.2701544],
        [4.0469749, 44.3190750],
        [3.8756098, 44.7401566],
        [3.6302471, 44.8809450],
        [3.4792607, 44.8091763],
        [3.3727057, 44.9757235],
        [3.1031984, 44.8861648],
        [2.9814201, 44.6445942],
        [2.7382979, 44.9413952],
        [2.4831885, 44.6503416],
        [2.2073879, 44.6155612],
        [2.0628961, 44.9766424],
        [2.3506555, 45.4129145],
        [2.5288344, 45.3923753],
        [2.3874919, 45.8275254],
        [2.6027008, 46.0328766],
        [2.2807797, 46.4203961],
        [2.7149828, 46.7450755],
        [3.0322025, 46.7947734],
        [3.4565666, 46.6516729],
        [3.6266572, 46.7521415],
        [4.0003579, 46.4629323],
        [3.9897592, 46.1693055],
        [4.6795382, 46.3064642],
        [4.7802194, 46.1767053],
        [4.9416461, 46.5198836],
        [5.2020080, 46.5082813],
        [5.4737894, 46.2645127],
        [5.8695898, 46.2651441],
        [6.0639599, 46.4163412],
        [5.9570798, 46.1288434],
        [6.2949608, 46.2255127],
        [6.3050312, 46.3665324],
        [6.7484868, 46.4041737],
        [7.0370401, 45.9545229],
        [6.8085077, 45.7260022],
        [7.1848148, 45.4074144],
        [7.1372141, 45.2572539],
        [6.6817834, 45.1397339],
        [6.2461858, 45.1202522],
        [6.3539549, 44.8534769],
        [6.0159349, 44.8354854],
        [5.6417177, 44.6510778],
        [5.6114663, 44.4693788],
        [5.4582781, 44.4992578],
        [5.6786094, 44.1460907],
        [5.4547125, 44.1192279],
        [5.1677511, 44.3148286],
        [4.6495238, 44.2701544]
      ]
    ]
  },
  {
    value: 'bfc',
    label: 'Bourgogne-Franche-Comté',
    states: ['21', '25', '39', '58', '70', '71', '89', '90'],
    coordinates: [
      [
        [6.0639599, 46.4163412],
        [5.8695898, 46.2651441],
        [5.4737894, 46.2645127],
        [5.2020080, 46.5082813],
        [4.9416461, 46.5198836],
        [4.7802194, 46.1767053],
        [4.6795382, 46.3064642],
        [3.9897592, 46.1693055],
        [4.0003579, 46.4629323],
        [3.6266572, 46.7521415],
        [3.4565666, 46.6516729],
        [3.0322025, 46.7947734],
        [2.8486469, 47.7259326],
        [3.1286102, 47.9834332],
        [2.9361436, 48.1632957],
        [3.0495359, 48.3600157],
        [3.4144660, 48.3903815],
        [3.9027585, 47.9249587],
        [4.7894165, 48.0078665],
        [4.9690926, 47.6858250],
        [5.2531200, 47.5768554],
        [5.6910556, 47.6846251],
        [5.6922372, 47.8213336],
        [6.1313951, 48.0240809],
        [7.0157855, 47.7434661],
        [7.1306553, 47.5028690],
        [6.0639599, 46.4163412]
      ]
    ]
  },
  {
    value: 'bre',
    label: 'Bretagne',
    states: ['22', '29', '35', '56'],
    coordinates: [
      [
        [-1.5710840, 48.6264372],
        [-1.4219364, 48.4604957],
        [-1.0699159, 48.5090254],
        [-1.0158118, 48.0032845],
        [-1.2458903, 47.7767145],
        [-1.4782204, 47.8358868],
        [-2.4800728, 47.4412363],
        [-3.1307112, 47.4731292],
        [-3.2878703, 47.7009578],
        [-3.9459991, 47.9045176],
        [-4.3741649, 47.7979771],
        [-4.4225440, 47.9624361],
        [-4.7411312, 48.0401141],
        [-4.2964853, 48.0924446],
        [-4.6313944, 48.2794137],
        [-4.2778353, 48.3447463],
        [-4.7710937, 48.3285843],
        [-4.7760175, 48.5191723],
        [-4.0069541, 48.7273441],
        [-3.8553925, 48.6201734],
        [-3.8232124, 48.7194919],
        [-3.5816411, 48.6706918],
        [-3.5051194, 48.8401890],
        [-3.0718485, 48.8841174],
        [-2.6765954, 48.4907960],
        [-2.3179887, 48.6886402],
        [-1.9658935, 48.5117400],
        [-1.9369219, 48.7025164],
        [-1.5710840, 48.6264372]
      ]
    ]
  },
  {
    value: 'cvl',
    label: 'Centre-Val de Loire',
    states: ['18', '28', '36', '37', '41', '45'],
    coordinates: [
      [
        [0.0537417, 47.1646105],
        [0.2307080, 47.6106640],
        [0.4025855, 47.5785138],
        [0.8176072, 47.8927861],
        [0.7976627, 48.1944555],
        [0.9765041, 48.4406155],
        [0.8095948, 48.6660663],
        [1.3293951, 48.7610453],
        [1.5011856, 48.9408135],
        [1.9727904, 48.2884419],
        [2.4020135, 48.3207602],
        [2.4544402, 48.1224282],
        [2.9361436, 48.1632957],
        [3.1286102, 47.9834332],
        [2.8486469, 47.7259326],
        [3.0322025, 46.7947734],
        [2.7149828, 46.7450755],
        [2.2807797, 46.4203961],
        [1.1821309, 46.3760344],
        [0.6925565, 46.9734782],
        [0.3248365, 46.9306504],
        [0.0537417, 47.16461059]
      ]
    ]
  },
  {
    value: 'cor',
    label: 'Corse',
    states: ['2A', '2B', '20'],
    coordinates: [
      [
        [9.3948261, 41.8607944],
        [9.1800987, 41.3659432],
        [8.7867557, 41.5557968],
        [8.9160980, 41.6879753],
        [8.6581286, 41.7406561],
        [8.8028386, 41.8949248],
        [8.6070885, 41.8952863],
        [8.7471986, 42.0503460],
        [8.5397375, 42.2367150],
        [8.6930189, 42.2680852],
        [8.5429775, 42.3683854],
        [8.7091469, 42.5766348],
        [9.3156065, 42.6899076],
        [9.4217636, 43.0118455],
        [9.5590280, 42.1965661],
        [9.3948261, 41.8607944]
      ]
    ]
  },
  {
    value: 'ges',
    label: 'Grand Est',
    states: ['08', '10', '51', '52', '54', '55', '57', '67', '68', '88'],
    coordinates: [
      [
        [7.1306553, 47.5028690],
        [7.0157855, 47.7434661],
        [6.1313951, 48.0240809],
        [5.6922372, 47.8213336],
        [5.6910556, 47.6846251],
        [5.2531200, 47.5768554],
        [4.9690926, 47.6858250],
        [4.7894165, 48.0078665],
        [3.9027585, 47.9249587],
        [3.4144660, 48.3903815],
        [3.4850917, 48.8520350],
        [3.7487706, 49.1570807],
        [3.6439438, 49.3127141],
        [4.0354525, 49.3601196],
        [4.2330770, 49.9577641],
        [4.6935917, 49.9952478],
        [4.8256362, 50.1688881],
        [4.8514641, 49.7933854],
        [5.4650096, 49.4987059],
        [6.2407985, 49.5146979],
        [6.5417707, 49.4323539],
        [6.7385001, 49.1636432],
        [7.4456498, 49.1841116],
        [8.2265502, 48.9740160],
        [7.5778505, 48.1218141],
        [7.5845330, 47.5754484],
        [7.3856353, 47.4321100],
        [7.1306553, 47.5028690]
      ]
    ]
  },
  {
    value: 'hdf',
    label: 'Hauts-de-France',
    states: ['02', '59', '60', '62', '80'],
    coordinates: [
      [
        [4.2330770, 49.9577641],
        [4.0354525, 49.3601196],
        [3.6439438, 49.3127141],
        [3.7487706, 49.1570807],
        [3.4850917, 48.8520350],
        [3.1370139, 49.1075694],
        [1.7041672, 49.2324248],
        [1.7862850, 49.7620581],
        [1.3798246, 50.0651112],
        [1.6884187, 50.1879560],
        [1.5378908, 50.2814542],
        [1.5824764, 50.8715980],
        [2.5456420, 51.0890728],
        [2.7905854, 50.7259244],
        [3.1499785, 50.7901174],
        [3.2883710, 50.5257732],
        [3.6076598, 50.4972617],
        [3.7101902, 50.3031790],
        [4.2080680, 50.2729697],
        [4.2330770, 49.9577641]
      ]
    ]
  },
  {
    value: 'idf',
    label: 'Île-de-France',
    states: ['75', '77', '78', '91', '92', '93', '94', '95'],
    coordinates: [
      [
        [1.7041672, 49.2324248],
        [3.1370139, 49.1075694],
        [3.4850917, 48.8520350],
        [3.4144660, 48.3903815],
        [3.0495359, 48.3600157],
        [2.9361436, 48.1632957],
        [2.4544402, 48.1224282],
        [2.4020135, 48.3207602],
        [1.9727904, 48.2884419],
        [1.5011856, 48.9408135],
        [1.7041672, 49.2324248]
      ]
    ]
  },
  {
    value: 'nor',
    label: 'Normandie',
    states: ['14', '27', '50', '61', '76'],
    coordinates: [
      [
        [1.7041672, 49.2324248],
        [1.5011856, 48.9408135],
        [1.3293951, 48.7610453],
        [0.8095948, 48.6660663],
        [0.9765041, 48.4406155],
        [0.7976627, 48.1944555],
        [0.3267827, 48.4716961],
        [0.1219126, 48.4361687],
        [0.1218891, 48.4361754],
        [0.1111924, 48.4321670],
        [0.1110175, 48.4319483],
        [0.1108620, 48.4317465],
        [0.1108318, 48.4317284],
        [0.1107819, 48.4316986],
        [0.1106953, 48.4315878],
        [0.1098383, 48.4307689],
        [0.1096287, 48.4306011],
        [0.1072416, 48.4275772],
        [0.1070355, 48.4272920],
        [0.1066305, 48.4268042],
        [0.1065295, 48.4267054],
        [0.1063717, 48.4264829],
        [0.1064267, 48.4264654],
        [0.1066921, 48.4263777],
        [0.1076220, 48.4258461],
        [0.1098919, 48.4229667],
        [0.1087016, 48.4209277],
        [0.1078715, 48.4201382],
        [0.1076339, 48.4200451],
        [0.1073108, 48.4197824],
        [0.1072618, 48.4196970],
        [0.1072218, 48.4196169],
        [0.1072022, 48.4195691],
        [0.1071216, 48.4191369],
        [0.1071221, 48.4190874],
        [0.1069521, 48.4185370],
        [0.1068126, 48.4182871],
        [0.1065926, 48.4179285],
        [0.1063262, 48.4175690],
        [-0.0515880, 48.3757989],
        [-0.2426257, 48.5679985],
        [-0.6510663, 48.4439523],
        [-1.0699159, 48.5090254],
        [-1.4219364, 48.4604957],
        [-1.5710840, 48.6264372],
        [-1.3453847, 48.6325864],
        [-1.5710036, 48.7442257],
        [-1.6053508, 49.2055821],
        [-1.9421769, 49.7260999],
        [-1.2664788, 49.6955996],
        [-1.1171806, 49.3448508],
        [-0.2487749, 49.2600857],
        [0.2972106, 49.4298547],
        [0.0652097, 49.5121449],
        [0.2059891, 49.7141844],
        [1.3798246, 50.0651112],
        [1.7862850, 49.7620581],
        [1.7041672, 49.2324248]
      ]
    ]
  },
  {
    value: 'naq',
    label: 'Nouvelle-Aquitaine',
    states: ['16', '17', '19', '23', '24', '33', '40', '47', '64', '79', '86', '87'],
    coordinates: [
      [
        [-0.3134467, 42.8493738],
        [-0.5515285, 42.7777028],
        [-0.7520309, 42.9674960],
        [-1.2712933, 43.1185383],
        [-1.4398938, 43.0460176],
        [-1.3889343, 43.2586790],
        [-1.7893458, 43.3551590],
        [-1.4489050, 43.6402516],
        [-1.1953113, 44.6572482],
        [-1.0046010, 44.6509376],
        [-1.1672308, 44.7759606],
        [-1.2616102, 44.6339288],
        [-1.0865767, 45.5649951],
        [-0.5912261, 45.0116006],
        [-0.7729481, 45.4490424],
        [-1.2327964, 45.6851447],
        [-1.0530757, 46.0038346],
        [-1.2415486, 46.1594849],
        [-1.1298070, 46.3108052],
        [-0.5377936, 46.3864659],
        [-0.9032615, 46.9714631],
        [0.0537417, 47.1646105],
        [0.3248365, 46.9306504],
        [0.6925565, 46.9734782],
        [1.1821309, 46.3760344],
        [2.2807797, 46.4203961],
        [2.6027008, 46.0328766],
        [2.3874919, 45.8275254],
        [2.5288344, 45.3923753],
        [2.3506555, 45.4129145],
        [2.0628961, 44.9766424],
        [1.4091825, 45.0067714],
        [1.3157335, 44.7404594],
        [0.9815409, 44.5444778],
        [0.8940220, 44.1380159],
        [-0.2283969, 43.9112961],
        [-0.2797354, 43.6184038],
        [0.0296972, 43.3459309],
        [-0.3134467, 42.8493738]
      ]
    ]
  },
  {
    value: 'occ',
    label: 'Occitanie',
    states: ['09', '11', '12', '30', '31', '32', '34', '46', '48', '65', '66', '81', '82'],
    coordinates: [
      [
        [-0.3134467, 42.8493738],
        [0.0296972, 43.3459309],
        [-0.2797354, 43.6184038],
        [-0.2283969, 43.9112961],
        [0.8940220, 44.1380159],
        [0.9815409, 44.5444778],
        [1.3157335, 44.7404594],
        [1.4091825, 45.0067714],
        [2.0628961, 44.9766424],
        [2.2073879, 44.6155612],
        [2.4831885, 44.6503416],
        [2.7382979, 44.9413952],
        [2.9814201, 44.6445942],
        [3.1031984, 44.8861648],
        [3.3727057, 44.9757235],
        [3.4792607, 44.8091763],
        [3.6302471, 44.8809450],
        [3.8756098, 44.7401566],
        [4.0469749, 44.3190750],
        [4.6495238, 44.2701544],
        [4.8445359, 43.9972792],
        [4.8445388, 43.9971833],
        [4.8445744, 43.9963096],
        [4.8446261, 43.9949924],
        [4.8446643, 43.9946298],
        [4.8450244, 43.9919905],
        [4.8450889, 43.9915130],
        [4.8451757, 43.9908607],
        [4.8451095, 43.9901058],
        [4.8450452, 43.9893601],
        [4.8447657, 43.9888173],
        [4.8447579, 43.9888031],
        [4.8430746, 43.9873703],
        [4.8413786, 43.9863592],
        [4.8412452, 43.9862798],
        [4.8399220, 43.9856301],
        [4.8392956, 43.9854405],
        [4.8338857, 43.9850702],
        [4.8312456, 43.9852699],
        [4.8288648, 43.9856892],
        [4.8275014, 43.9860719],
        [4.8255149, 43.9866295],
        [4.8249647, 43.9868739],
        [4.8249267, 43.9868872],
        [4.8246553, 43.9869799],
        [4.8242950, 43.9870304],
        [4.8242539, 43.9870386],
        [4.8242229, 43.9870455],
        [4.8234351, 43.9872109],
        [4.8231475, 43.9873256],
        [4.8168350, 43.9887702],
        [4.8154552, 43.9887800],
        [4.8150606, 43.9887004],
        [4.8148979, 43.9886680],
        [4.8123352, 43.9874094],
        [4.8120867, 43.9871121],
        [4.8106951, 43.9837080],
        [4.8106948, 43.9837008],
        [4.8107397, 43.9817830],
        [4.8106242, 43.9790043],
        [4.8106410, 43.9785700],
        [4.8112135, 43.9758931],
        [4.8118050, 43.9744699],
        [4.8119504, 43.9742698],
        [4.8124635, 43.9735687],
        [4.8141953, 43.9696999],
        [4.8145185, 43.9690609],
        [4.8126244, 43.9626335],
        [4.8121454, 43.9622497],
        [4.8115188, 43.9618188],
        [4.8107981, 43.9613220],
        [4.8090662, 43.9604700],
        [4.8085377, 43.9602584],
        [4.8065920, 43.9595740],
        [4.8056148, 43.9592809],
        [4.8046689, 43.9590478],
        [4.8037849, 43.9588298],
        [4.8017761, 43.9582993],
        [4.8000789, 43.9578163],
        [4.7998579, 43.9577533],
        [4.7957034, 43.9557997],
        [4.7946258, 43.9551604],
        [4.7937244, 43.9544058],
        [4.7933351, 43.9540797],
        [4.7930065, 43.9537697],
        [4.7917964, 43.9524399],
        [4.7927301, 43.9522931],
        [4.7885560, 43.9469998],
        [4.7872232, 43.9456954],
        [4.7871652, 43.9456400],
        [4.7858261, 43.9444202],
        [4.7635547, 43.9355161],
        [4.7617954, 43.9352894],
        [4.7599742, 43.9350168],
        [4.7540453, 43.9336493],
        [4.7518655, 43.9328888],
        [4.7479552, 43.9309291],
        [4.7447357, 43.9286788],
        [4.7414871, 43.9259344],
        [4.7403649, 43.9248185],
        [4.7392520, 43.9239218],
        [4.7390246, 43.9237383],
        [4.6273763, 43.6854074],
        [4.2299761, 43.4605190],
        [4.0070073, 43.5516560],
        [3.2204963, 43.1997013],
        [3.0391681, 42.9397537],
        [3.1776429, 42.4390254],
        [2.6710467, 42.3407134],
        [2.2563886, 42.4383111],
        [2.0159596, 42.3470394],
        [1.7365653, 42.6178341],
        [0.7087605, 42.8612567],
        [0.6770208, 42.6909256],
        [0.2960133, 42.6739044],
        [-0.3134467, 42.8493738]
      ]
    ]
  },
  {
    value: 'dom',
    label: 'Outre-mer',
    states: ['97', '971', '972', '973', '974', '975', '976', '977', '978', '984', '986', '987', '988', '989']
  },
  {
    value: 'pdl',
    label: 'Pays de la Loire',
    states: ['44', '49', '53', '72', '85'],
    coordinates: [
      [
        [0.0537417, 47.1646105],
        [-0.9032615, 46.9714631],
        [-0.5377936, 46.3864659],
        [-1.1298070, 46.3108052],
        [-1.8123481, 46.4934185],
        [-2.1434743, 46.8226056],
        [-1.9804178, 47.0289018],
        [-2.2472246, 47.1324658],
        [-2.1872887, 47.2806573],
        [-2.5458795, 47.2903267],
        [-2.4800728, 47.4412363],
        [-1.4782204, 47.8358868],
        [-1.2458903, 47.7767145],
        [-1.0158118, 48.0032845],
        [-1.0699159, 48.5090254],
        [-0.6510663, 48.4439523],
        [-0.2426257, 48.5679985],
        [-0.0515880, 48.3757989],
        [0.1063262, 48.4175690],
        [0.1065926, 48.4179285],
        [0.1068126, 48.4182871],
        [0.1069521, 48.4185370],
        [0.1071221, 48.4190874],
        [0.1071216, 48.4191369],
        [0.1072022, 48.4195691],
        [0.1072218, 48.4196169],
        [0.1072618, 48.4196970],
        [0.1073108, 48.4197824],
        [0.1076339, 48.4200451],
        [0.1078715, 48.4201382],
        [0.1087016, 48.4209277],
        [0.1098919, 48.4229667],
        [0.1076220, 48.4258461],
        [0.1066921, 48.4263777],
        [0.1064267, 48.4264654],
        [0.1063717, 48.4264829],
        [0.1065295, 48.4267054],
        [0.1066305, 48.4268042],
        [0.1070355, 48.4272920],
        [0.1072416, 48.4275772],
        [0.1096287, 48.4306011],
        [0.1098383, 48.4307689],
        [0.1106953, 48.4315878],
        [0.1107819, 48.4316986],
        [0.1108318, 48.4317284],
        [0.1108620, 48.4317465],
        [0.1110175, 48.4319483],
        [0.1111924, 48.4321670],
        [0.1218891, 48.4361754],
        [0.1219126, 48.4361687],
        [0.3267827, 48.4716961],
        [0.7976627, 48.1944555],
        [0.8176072, 47.8927861],
        [0.4025855, 47.5785138],
        [0.2307080, 47.6106640],
        [0.0537417, 47.1646105]
      ]
    ]
  },
  {
    value: 'pac',
    label: 'Provence-Alpes-Côte d\'Azur',
    states: ['04', '05', '06', '13', '83', '84'],
    coordinates: [
      [
        [4.7390246, 43.9237383],
        [4.7392520, 43.9239218],
        [4.7403649, 43.9248185],
        [4.7414871, 43.9259344],
        [4.7447357, 43.9286788],
        [4.7479552, 43.9309291],
        [4.7518655, 43.9328888],
        [4.7540453, 43.9336493],
        [4.7599742, 43.9350168],
        [4.7617954, 43.9352894],
        [4.7635547, 43.9355161],
        [4.7858261, 43.9444202],
        [4.7871652, 43.9456400],
        [4.7872232, 43.9456954],
        [4.7885560, 43.9469998],
        [4.7927301, 43.9522931],
        [4.7917964, 43.9524399],
        [4.7930065, 43.9537697],
        [4.7933351, 43.9540797],
        [4.7937244, 43.9544058],
        [4.7946258, 43.9551604],
        [4.7957034, 43.9557997],
        [4.7998579, 43.9577533],
        [4.8000789, 43.9578163],
        [4.8017761, 43.9582993],
        [4.8037849, 43.9588298],
        [4.8046689, 43.9590478],
        [4.8056148, 43.9592809],
        [4.8065920, 43.9595740],
        [4.8085377, 43.9602584],
        [4.8090662, 43.9604700],
        [4.8107981, 43.9613220],
        [4.8115188, 43.9618188],
        [4.8121454, 43.9622497],
        [4.8126244, 43.9626335],
        [4.8145185, 43.9690609],
        [4.8141953, 43.9696999],
        [4.8124635, 43.9735687],
        [4.8119504, 43.9742698],
        [4.8118050, 43.9744699],
        [4.8112135, 43.9758931],
        [4.8106410, 43.9785700],
        [4.8106242, 43.9790043],
        [4.8107397, 43.9817830],
        [4.8106948, 43.9837008],
        [4.8106951, 43.9837080],
        [4.8120867, 43.9871121],
        [4.8123352, 43.9874094],
        [4.8148979, 43.9886680],
        [4.8150606, 43.9887004],
        [4.8154552, 43.9887800],
        [4.8168350, 43.9887702],
        [4.8231475, 43.9873256],
        [4.8234351, 43.9872109],
        [4.8242229, 43.9870455],
        [4.8242539, 43.9870386],
        [4.8242950, 43.9870304],
        [4.8246553, 43.9869799],
        [4.8249267, 43.9868872],
        [4.8249647, 43.9868739],
        [4.8255149, 43.9866295],
        [4.8275014, 43.9860719],
        [4.8288648, 43.9856892],
        [4.8312456, 43.9852699],
        [4.8338857, 43.9850702],
        [4.8392956, 43.9854405],
        [4.8399220, 43.9856301],
        [4.8412452, 43.9862798],
        [4.8413786, 43.9863592],
        [4.8430746, 43.9873703],
        [4.8447579, 43.9888031],
        [4.8447657, 43.9888173],
        [4.8450452, 43.9893601],
        [4.8451095, 43.9901058],
        [4.8451757, 43.9908607],
        [4.8450889, 43.9915130],
        [4.8450244, 43.9919905],
        [4.8446643, 43.9946298],
        [4.8446261, 43.9949924],
        [4.8445744, 43.9963096],
        [4.8445388, 43.9971833],
        [4.8445359, 43.9972792],
        [4.6495238, 44.2701544],
        [5.1677511, 44.3148286],
        [5.4547125, 44.1192279],
        [5.6786094, 44.1460907],
        [5.4582781, 44.4992578],
        [5.6114663, 44.4693788],
        [5.6417177, 44.6510778],
        [6.0159349, 44.8354854],
        [6.3539549, 44.8534769],
        [6.2461858, 45.1202522],
        [6.6817834, 45.1397339],
        [7.0753709, 44.6902975],
        [6.8535331, 44.5292591],
        [7.0088428, 44.2354506],
        [7.3594420, 44.1162016],
        [7.6840196, 44.1739248],
        [7.5299245, 43.7840841],
        [7.3037401, 43.6856511],
        [7.1255848, 43.5935472],
        [7.1294213, 43.5912148],
        [7.1257650, 43.5869513],
        [7.1256871, 43.5870538],
        [7.1303535, 43.5824583],
        [6.7463891, 43.4230946],
        [6.6463732, 43.1674058],
        [5.9038089, 43.0792233],
        [5.8797477, 43.0720973],
        [5.8784674, 43.0709311],
        [5.8649307, 43.0593088],
        [5.8604571, 43.0494078],
        [5.8589753, 43.0458960],
        [5.3735791, 43.2592995],
        [5.3726363, 43.2591160],
        [5.3699824, 43.2612296],
        [5.3693028, 43.2637882],
        [5.0190594, 43.3419109],
        [5.2298381, 43.4652415],
        [5.0210362, 43.5566099],
        [5.0591883, 43.4066404],
        [4.8282279, 43.4298300],
        [4.8417098, 43.3284212],
        [4.2299761, 43.4605190],
        [4.6273763, 43.6854074],
        [4.7390246, 43.9237383]
      ]
    ]
  },
  {
    value: '1',
    label: 'TANGER TETOUAN AL HOCEIMA',
    states: ['MAR-74', 'MAR-75', 'MAR-76', 'MAR-77', 'MAR-78', 'MAR-79', 'MAR-80', 'MAR-81', 'MAR-82']
  },
  {
    value: '2',
    label: 'L\'ORIENTAL',
    states: ['MAR-39', 'MAR-40', 'MAR-41', 'MAR-42', 'MAR-43', 'MAR-44', 'MAR-45', 'MAR-46', 'MAR-47', 'MAR-48', 'MAR-49', 'MAR-50', 'MAR-51']
  },
  {
    value: '3',
    label: 'FES MEKNES',
    states: ['MAR-21', 'MAR-22', 'MAR-23', 'MAR-24', 'MAR-25', 'MAR-26', 'MAR-27', 'MAR-28', 'MAR-29', 'MAR-16', 'MAR-30']
  },
  {
    value: '4',
    label: 'RABAT SALE KENITRA',
    states: ['MAR-62', 'MAR-63', 'MAR-64', 'MAR-65', 'MAR-66', 'MAR-67', 'MAR-84']
  },
  {
    value: '5',
    label: 'BENI MELLAL KHENIFRA',
    states: ['MAR-01', 'MAR-02', 'MAR-03', 'MAR-04', 'MAR-05']
  },
  {
    value: '6',
    label: 'CASABLANCA SETTAT',
    states: ['MAR-06', 'MAR-07', 'MAR-08', 'MAR-09', 'MAR-10', 'MAR-11', 'MAR-12', 'MAR-13', 'MAR-83']
  },
  {
    value: '7',
    label: 'MARRAKECH SAFI',
    states: ['MAR-52', 'MAR-53', 'MAR-54', 'MAR-55', 'MAR-56', 'MAR-57', 'MAR-58', 'MAR-59', 'MAR-60', 'MAR-61']
  },
  {
    value: '8',
    label: 'DRAA TAFILALET',
    states: ['MAR-16', 'MAR-17', 'MAR-18', 'MAR-19', 'MAR-20']
  },
  {
    value: '9',
    label: 'SOUSS MASSA',
    states: ['MAR-68', 'MAR-69', 'MAR-70', 'MAR-71', 'MAR-72', 'MAR-73']
  },
  {
    value: '10',
    label: 'GUELMIM OUED NOUN',
    states: ['MAR-31', 'MAR-32', 'MAR-33', 'MAR-34']
  },
  {
    value: '11',
    label: 'LAAYOUNE SAKIA EL HAMRA',
    states: ['MAR-35', 'MAR-36', 'MAR-37', 'MAR-38']
  },
  {
    value: '12',
    label: 'DAKHLA OUED EDDAHAB',
    states: ['MAR-14', 'MAR-15']
  }
]



// WEBPACK FOOTER //
// ./src/mixins/RegionsValues.js